<div class="manager-will-call">Менеджер уточнит условия доставки после оформления заказа</div>
